import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import listMixin from '@/components/niotaClassic/listMixin';
import { isCopyToClipboardSupported, copyToClipboard as _copyToClipboard } from '../../../utils/vuex';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicDevicetypesLinkedDevicesList',
  mixins: [listMixin],
  props: {
    deviceTypeId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      lastSearch: '',
      deviceUpdateDialog: false,
      deviceSingleUpdateDialog: false,
      deleteFromActility: false,
      isActility: false,
      editedItem: null,
      deviceTypes: [],
      applications: [],
      selectedRows: [],
      tableOptions: defaultTableOptions,
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    tableHeaders: function tableHeaders() {
      return [{
        text: this.$i18n_t('NiotaClassic.Common.table.id'),
        value: 'id',
        align: 'right'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.title'),
        value: 'title'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.eui'),
        value: 'eui'
      }, {
        text: this.$i18n_t('NiotaClassic.DeviceTypes.table.originator'),
        value: 'originator_title'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
        value: 'createdAt'
      }].concat(_toConsumableArray(this.isIotHubManager ? [{
        value: 'actions',
        width: '80px',
        sortable: false
      }] : []));
    }
  }),
  mounted: function mounted() {
    this.fetchList(true);
    this.deviceTypeFetchPlain();
    this.applicationsFetchPlain();
  },
  methods: {
    editDevice: function editDevice(item) {
      this.editedItem = cloneDeep(item);
      this.toggleEditDialog();
    },
    showDeletePrompt: function showDeletePrompt(item) {
      this.selectedItem = cloneDeep(item);
      this.isActility = (get(this.selectedItem, 'originator.type') || '').toLowerCase() === 'actility';
      this.deletePrompt = true;
    },

    /** closeDeletePrompt in listMixin */
    deleteFromRemote: function deleteFromRemote(remove) {
      this.deleteFromActility = remove;
    },
    deleteDevice: function deleteDevice() {
      var _this = this;

      var deletePromise = null;

      if (this.deleteFromActility) {
        deletePromise = NiotaClassicApiService.deviceDeleteFromActility(this.selectedItem.id);
      } else {
        deletePromise = NiotaClassicApiService.deviceDelete(this.selectedItem);
      }

      deletePromise.then(function () {
        _this.selectedItem == null;

        _this.$snack(_this.$i18n_t('NiotaClassic.Applications.snacks.deviceDeleteSuccess'), 'success');

        _this.refreshList();
      }).catch(function () {
        _this.$snack(_this.$i18n_t('NiotaClassic.Applications.snacks.deviceDeleteFailed'), 'error');
      }).finally(function () {
        _this.deletePrompt = false;
      });
    },
    toggleEditDialog: function toggleEditDialog() {
      this.deviceSingleUpdateDialog = !this.deviceSingleUpdateDialog;
    },
    toggleEditAllDialog: function toggleEditAllDialog() {
      this.deviceUpdateDialog = !this.deviceUpdateDialog;
    },
    rowSelectUpdate: function rowSelectUpdate(rows) {
      this.selectedRows = rows;
    },
    refreshList: function refreshList() {
      this.selectedRows = [];
      this.fetchList(true);
    },
    isCopySupported: function isCopySupported() {
      return isCopyToClipboardSupported();
    },
    copyToClipboard: function copyToClipboard(event, eui) {
      event.stopPropagation();

      _copyToClipboard(eui);
    },
    viewDevice: function viewDevice(item) {
      this.$router.push({
        path: "/niota-classic/devices/".concat(item.id, "/details")
      });
    },
    deviceTypeFetchPlain: function deviceTypeFetchPlain() {
      var _this2 = this;

      NiotaClassicApiService.deviceTypeFetchPlain().then(function (res) {
        _this2.deviceTypes = res.data.devicetypes;
      }).catch(function () {
        _this2.deviceTypes = [];

        _this2.$snack(_this2.$i18n_t('NiotaClassic.Applications.form.errorFindingDeviceTypes'), 'error');
      });
    },
    applicationsFetchPlain: function applicationsFetchPlain() {
      var _this3 = this;

      NiotaClassicApiService.applicationsFetchPlain().then(function (res) {
        _this3.applications = res.data.applications;
      }).catch(function () {
        _this3.applications = [];

        _this3.$snack(_this3.$i18n_t('NiotaClassic.Applications.form.errorFindingApplications'), 'error');
      });
    },
    fetchList: function fetchList(fromStart) {
      var _this4 = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var trimmedSearch = (this.searchItem || '').trim();

      if (this.lastSearch !== trimmedSearch) {
        this.lastSearch = trimmedSearch;
        this.tableOptions = defaultTableOptions;
      }

      var tableOptions = fromStart ? _objectSpread(_objectSpread({}, this.tableOptions), {}, {
        page: 1
      }) : this.tableOptions;
      var sortBy = tableOptions.sortBy,
          sortDesc = tableOptions.sortDesc,
          page = tableOptions.page,
          itemsPerPage = tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = page || 1;
      var usedItemsPerPage = itemsPerPage ? itemsPerPage : defaultItemsPerPage;
      NiotaClassicApiService.getDeviceTypeDevices(this.deviceTypeId, trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection).then(function (res) {
        _this4.list = res.data.devices;
        _this4.serverItemsLength = res.pagination.itemCount;
      }).catch(function () {
        _this4.$snack(_this4.$i18n_t('NiotaClassic.DeviceTypes.snacks.fetchFailed'), 'error');
      }).finally(function () {
        _this4.isFetching = false;
      });
    }
  }
};